import request from '@/axios'

export function getSetting (customer_id) {
  return request({
    url: `/setting/${customer_id}`,
    method: 'GET'
  })
}

export function setSettings (customer_id, payload) {
  return request({
    url: `/setting/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function verificationMailSend (platform_customer_id, payload) {
  return request({
    url: `verificationMailSend/${platform_customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function currencyApi (customer_id, payload) {
  return request({
    url: `/currency_setting/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function getSchoolInfo (customer_id) {
  return request({
    url: `/users/school_details/${customer_id}`,
    method: 'GET'
  })
}

export function templateDetailsFetch (customer_id, flag,payload) {
  return request({
    url: `/communication/template/details/${customer_id}/${flag}`,
    method: 'POST',
    data: payload
  })
}

// http://localhost:8000/api/setting/2
